import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// components
import User from "./User";

// styles
const RightBlockStyled = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: 1;
`;

// component
export const RightBlock = ({
    className,
    isDisabled = false,
    onFocusScroll
}) => {
    return (
        <RightBlockStyled className={className}>
            <User isDisabled={isDisabled} onFocusScroll={onFocusScroll} />
        </RightBlockStyled>
    );
};

export default RightBlock;

// prop-types
RightBlock.propTypes = {
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    onFocusScroll: PropTypes.func
};
